var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHI3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.799 3.544a2.034 2.034 0 11-3.53-2.022 2.034 2.034 0 013.53 2.022zm45.365 16.479a1.52 1.52 0 11-2.64-1.51 1.52 1.52 0 012.64 1.51zm-31.467 10.3H33.2a1.011 1.011 0 000-2.022H17.697a1.012 1.012 0 000 2.022zm0 6.066H33.2a1.011 1.011 0 000-2.022H17.697a1.011 1.011 0 000 2.023zm10.11-14.154h-10.11a1.012 1.012 0 000 2.022h10.11a1.011 1.011 0 000-2.022zm4.719-6.067H17.697a1.011 1.011 0 000 2.023h14.829a1.011 1.011 0 000-2.023zM11.968 6.058h26.961a2.696 2.696 0 012.696 2.696v35.05A2.696 2.696 0 0138.93 46.5H11.968a2.696 2.696 0 01-2.696-2.696v-4.381H5.078a1.011 1.011 0 010-2.023h4.194v-6.066H5.078a1.011 1.011 0 010-2.022h4.194v-6.066H5.078a1.011 1.011 0 010-2.022h4.194v-6.067H5.078a1.011 1.011 0 010-2.022h4.194V8.754a2.696 2.696 0 012.696-2.696z",
    fill: "url(#h-i3_svg__paint0_linear_0_6422)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "h-i3_svg__paint0_linear_0_6422",
    x1: -24.683,
    y1: 20.873,
    x2: 15.619,
    y2: 69.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ac1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#F85691"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C2D"
  })))));
}
export default SvgHI3;